import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import { ArrowLeftIcon } from '../../../../components/Icon';

const useStyles = makeStyles((theme) => ({
  head: {
    display: 'flex',
    height: '3.75rem',
    alignItems: 'center',
    borderBottom: '0.0625rem solid #e4e7eb',
  },
  headbtn: {
    width: '1.5rem',
    height: '1.5rem',
    marginLeft: '1.25rem',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  headicon: {
    fontSize: '1rem',
    color: theme.palette.primary.main,
  },
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    marginLeft: '5.138rem',
  },
}));

export default function Header({ backOnclick, title }) {
  const classes = useStyles();
  return (
    <div className={classes.head}>
      <IconButton className={classes.headbtn} onClick={backOnclick} id="DutyAssign-IconButton-abz">
        <ArrowLeftIcon className={classes.headicon} />
      </IconButton>
      <div className={classes.title}>{title}</div>
    </div>
  );
}
